import React from "react";
import classes from "../profileComponents/ProfileComponents.module.scss";
import { IconButton } from "@mui/material";
import { ReactComponent as DownloadIcon } from "../../assets/downloadIcon.svg";
import axios from "axios";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const CertificateField = ({ isEditMode, certificateId, serviceCode, className }) => {
  const onFileUploadHandler = (e) => {
    let fileUploadEndpoint;
    // console.log(certificateId);
    const certificateIdParsed = certificateId?.split("/")[1];
    // console.log(e.target.files[0]);
    const fileData = new FormData();

    if (certificateId) {
      fileUploadEndpoint =
        // "https://" + window.location.hostname + "/File/" + certificateIdParsed;
        `https://dev.e-invoices.online/File/${certificateIdParsed}`;
    } else {
      // fileUploadEndpoint = "https://" + window.location.hostname + "/File";
      fileUploadEndpoint = "https://dev.e-invoices.online/File";
    }

    fileData.append("file", e.target.files[0]);

    axios
      .post(fileUploadEndpoint, fileData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.Result && res.data.Status.toUpperCase() === "OK") {
          if (!certificateId) {
            let certPath = `File/${res.data.Result.Id}`;
            // passCertId(certPath);
            // console.log(certPath);
            axios
              .post(
                apiRequestAddress,
                {
                  jsonrpc: "2.0",
                  method: "Data.Modify",
                  params: {
                    entity: "EU_AOrg_ServicesEndpoints",
                    filter: "ServiceEndPointCode='" + serviceCode + "'",
                    values: { Certificate: certPath },
                  },
                  id: 5123,
                },
                {
                  withCredentials: true,
                }
              )
              .then((res) => console.log(res));
          }
        }
      });
  };

  // useEffect(() => {
  //   let fileUploadEndpoint;
  //   const certificateIdParsed = certificateId?.split("/")[1];
  //   if (certificateId) {
  //     fileUploadEndpoint =
  //       // "https://" + window.location.hostname + "/File/" + certificateIdParsed;
  //       `https://dev.e-invoices.online/File/${certificateIdParsed}`;
  //   } else {
  //     // fileUploadEndpoint = "https://" + window.location.hostname + "/File";
  //     fileUploadEndpoint = "https://dev.e-invoices.online/File";
  //   }
  //   console.log("fired useeffect");
  //   console.log(fileData);
  //   if (uploadCert) {
  //     console.log("uploadCert true");
  //     console.log(uploadCert);
  //     // axios
  //     //   .post(fileUploadEndpoint, fileData, {
  //     //     headers: {
  //     //       "Content-Type": "multipart/form-data",
  //     //     },
  //     //     withCredentials: true,
  //     //   })
  //     //   .then((res) => {
  //     //     console.log(res);
  //     //     if (res.data.Result && res.data.Status.toUpperCase() === "OK") {
  //     //       if (!certificateId) {
  //     //         let certPath = `File/${res.data.Result.Id}`;
  //     //         passCertId(certPath);
  //     //         axios.post(
  //     //           apiRequestAddress,
  //     //           {
  //     //             jsonrpc: "2.0",
  //     //             method: "Data.Modify",
  //     //             params: {
  //     //               entity: "EU_AOrg_ServicesEndpoints",
  //     //               filter: "ServiceEndPointCode='" + serviceCode + "'",
  //     //               values: { Certificate: certPath },
  //     //             },
  //     //             id: 5123,
  //     //           },
  //     //           {
  //     //             withCredentials: true,
  //     //           }
  //     //         );
  //     //       }
  //     //     }
  //     //   });
  //   }
  // }, [uploadCert]);

  return (
    <>
      {!isEditMode && (
        <div className={classes["input-container"]} disabled={!isEditMode}>
          <div className={classes["fake-input-field"]}>
            <span className={className}>{certificateId ? certificateId : "No file uploaded"}</span>
            {certificateId && (
              <IconButton
                component="a"
                href={`https://${window.location.hostname}/${certificateId}`}
                download={`https://${window.location.hostname}/${certificateId}`}
                aria-label="Download"
                // disabled={!item.Certificate}
              >
                <DownloadIcon />
              </IconButton>
            )}
          </div>
        </div>
      )}
      {isEditMode && (
        <fieldset
          className={classes["upload-container"]}
          disabled={!isEditMode}
        >
          {/* <label htmlFor="certificate">
            {`Certificate (${certificateId?.substring(0, 15)}...)`}
          </label> */}
          <input
            type="file"
            name="certificate"
            id="certificate"
            onChange={onFileUploadHandler}
          />
        </fieldset>
      )}
    </>
  );
};

export default CertificateField;
